function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveRadioBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 7.42857,
    stroke: "#7ECEA7",
    style: {
      stroke: "#7ECEA7",
      stroke: "color(display-p3 0.4941 0.8078 0.6549)",
      strokeOpacity: 1
    },
    strokeWidth: 1.14286
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.99665,
    cy: 8.49665,
    r: 2.28571,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveRadioBtn);
export default __webpack_public_path__ + "static/media/inactiveRadioBtn.bab4fa6dcee2c15c79769134e79f4213.svg";
export { ForwardRef as ReactComponent };